import { thunk, Action, Thunk, action, Computed, computed } from 'easy-peasy'
import { sendTxFailLog, updateTx } from './helpers'
import { Transaction } from '../../atoms'
import { GAtrack } from '../../services/ga'
import { captureMessage } from '@sentry/react'

export interface TransactionModel {
    transactions: Record<string, Transaction>

    setTransactions: Action<TransactionModel, Record<string, Transaction>>
    loadTransaction: Thunk<TransactionModel, { txPayload: Record<string, Transaction>; isGoogleLog: boolean }>
    updateTransaction: Action<TransactionModel, { hash: string; payload: Transaction }>
    // eslint-disable-next-line no-unused-vars
    getTransaction: Computed<TransactionModel, (hash: string) => Transaction>
    getTransactions: Computed<TransactionModel, Transaction[]>
    // eslint-disable-next-line no-unused-vars
    getTransactionsByType: Computed<TransactionModel, (type: string) => (Transaction | undefined)[]>
}

const sentStatus = [] as string[]
const trasactionModel: TransactionModel = {
    transactions: {},

    setTransactions: action((state, payload) => {
        state.transactions = { ...state.transactions, ...payload }
    }),

    updateTransaction: action((state, payload) => {
        state.transactions[payload.hash] = payload.payload
    }),

    loadTransaction: thunk(async (actions, payload, helpers) => {
        const { txPayload, isGoogleLog } = payload
        actions.setTransactions(txPayload)

        const intervalId = setInterval(async () => {
            // update tx status over time
            const prevTx = Object.values(txPayload)[0]
            const tx = helpers.getState().getTransaction(prevTx.hash)
            const txStatus = await updateTx(tx.hash)

            if (txStatus && txStatus.tx_status !== tx.hash && !sentStatus.includes(tx.hash)) {
                if (txStatus.tx_status.includes('ACCEPTED')) {
                    sentStatus.push(tx.hash)
                    if (intervalId) {
                        clearInterval(intervalId)
                    }
                    actions.updateTransaction({ hash: tx.hash, payload: { ...tx, status: txStatus.tx_status } })
                    if (isGoogleLog) GAtrack(`tx_${tx.type}_success`, `tx_${tx.type}_success`, 'success', 1)
                    setTimeout(() => {
                        actions.updateTransaction({ hash: tx.hash, payload: { ...tx, status: txStatus.tx_status, dismiss: true } })
                    }, 3000)
                } else if (txStatus.tx_status === 'REJECTED' || txStatus.tx_status === 'REVERTED') {
                    if (intervalId) {
                        clearInterval(intervalId)
                    }
                    sentStatus.push(tx.hash)
                    let error = ''
                    if (txStatus.tx_revert_reason?.includes('amount1 slippage')) error = 'failed due to slippage; manually set higher slippage or use a wider liquidity range'
                    if (txStatus.tx_revert_reason?.includes('amount0 slippage')) error = 'failed due to slippage; manually set higher slippage or use a wider liquidity range'
                    actions.updateTransaction({ hash: tx.hash, payload: { ...tx, status: txStatus.tx_status, error: error } })
                    // actions.updateTransaction({ hash: tx.hash, payload: { ...tx, status: txStatus.tx_status, error: txStatus.tx_failure_reason?.error_message } })
                    const timeStampFailed = new Date().getTime()

                    if (isGoogleLog) {
                        const label = `tx_${tx.type}_fail hash = ${tx.hash}, sentTimestamp = ${tx.labelFields?.timestampSent}, timeStampFailed = ${timeStampFailed} ${
                            tx.labelFields?.sentCurrentTick ? `, sentCurrentTick = ${tx.labelFields?.sentCurrentTick}` : ''
                        }`
                        GAtrack(`tx_${tx.type}_fail`, `tx_${tx.type}_fail`, label, 0)
                        captureMessage(label, 'warning')
                        sendTxFailLog({
                            failedTimeStamp: timeStampFailed,
                            sentTimestamp: tx.labelFields!.timestampSent,
                            txHash: tx.hash,
                            currentTick: tx.labelFields?.sentCurrentTick ? tx.labelFields?.sentCurrentTick : undefined,
                            type: tx.type,
                            version: '1.0.0'
                        })
                    }
                }
            }
        }, 10000)
    }),

    getTransaction: computed((state) => (hash) => state.transactions[hash]),
    getTransactions: computed((state) => Object.values(state.transactions)),

    getTransactionsByType: computed((state) => (type) => {
        const txs: (Transaction | undefined)[] = []
        Object.values(state.transactions).map((tx) => {
            if (tx.type === type) txs.push(tx)
        })
        return txs
    })
}

export default trasactionModel
